import { useQuery } from '@tanstack/react-query'

import { getUserConsultStyleApi, getUserInfoApi } from '@/api/userApi'

export const useUserInfoQuery = (user_id: number) => {
  return useQuery({
    queryKey: ['userInfo', user_id],
    queryFn: () => getUserInfoApi(user_id)
  })
}

export const useUserConsultStyleQuery = (user_id: number) => {
  return useQuery({
    queryKey: ['userConsultStyle', user_id],
    queryFn: () => getUserConsultStyleApi(user_id)
  })
}
